import Box from '@mui/material/Box';
import type { InventoryBundle, InventoryDomain } from '@openx/types/gqlTypes.ts';
import { useDealPrompt } from './hooks/useDealPrompt.ts';
import { DealPromptAudienceDetailsMetricSection } from './parts/details/DealPromptAudienceDetailsMetricSection/DealPromptAudienceDetailsMetricSection.tsx';
import { DealPromptDetailsItemsTableSection } from './parts/details/DealPromptDetailsItemsTableSection.tsx';
import { DealPromptDetailsMetricsSection } from './parts/details/DealPromptDetailsMetricsSection.tsx';
import type { AudienceSegmentSetWithSegments } from './utils/getTilesData.ts';
import { dealPromptContextTypes } from './utils/types.ts';

export const DealPromptDetails = () => {
  const {
    state: { selectedTile, contextType },
  } = useDealPrompt();

  if (!selectedTile?.item) return null;

  const validItems =
    'results' in selectedTile.item
      ? ((selectedTile.item.results?.filter(d => !!d) ?? []) as InventoryDomain[] | InventoryBundle[])
      : [];

  const validAudienceItems =
    'segments' in selectedTile.item
      ? (selectedTile.item.segments?.filter(d => !!d) ?? []).map(segment => ({
          ...segment,
          account_name: segment.account_name === 'OpenAudience' ? 'OpenXSelect' : segment.account_name,
        }))
      : [];

  return (
    <Box data-test="deal-prompt-details" data-pendo-feature={`deal-prompt-details-${contextType}`}>
      {contextType !== dealPromptContextTypes.AUDIENCE && <DealPromptDetailsMetricsSection items={validItems} />}

      {contextType === dealPromptContextTypes.AUDIENCE && (
        <DealPromptAudienceDetailsMetricSection item={selectedTile.item as AudienceSegmentSetWithSegments} />
      )}

      <DealPromptDetailsItemsTableSection
        items={contextType === dealPromptContextTypes.AUDIENCE ? validAudienceItems : validItems}
      />
    </Box>
  );
};
